import moment from 'moment';

export const CURR_YEAR_END_DATE = moment()
  .endOf('year')
  .format('YYYY-MM-DD');

export const formatDate = (date, formatType, defaultDisplay = 'N/A') =>
  date ? moment.parseZone(date).format(formatType) : defaultDisplay;

export const convertDOBToAge = dob =>
  moment(CURR_YEAR_END_DATE).diff(moment(dob), 'years') || 0;

export const isDateInFuture = (dateToValidate, today = new Date()) =>
  moment(today).isBefore(dateToValidate);

export const currentYear = () => moment().year();

export const priorYear = moment()
  .subtract(12, 'months')
  .year();

export const isValidDate = str => moment(str, 'MM/DD/YYYY').isValid();

export const getDaysDiff = (date1, date2) => {
  const dt1 = new Date(date1);
  const dt2 = new Date(date2);

  return dt1.getDate() - dt2.getDate();
};

export const getMonthDiff = (date1, date2) => {
  const dt1 = new Date(date1);
  const dt2 = new Date(date2);

  return dt1.getMonth() - dt2.getMonth();
};
